import settings from '../../assets/settings.json';
import Cookies from 'js-cookie'


function convertZipKen(post_code){
  if(post_code.indexOf('-')!==-1){
    post_code = post_code.replace('-', '');
  }
  var api_url = 'https://zipcloud.ibsnet.co.jp/api/search?zipcode='+String(post_code);
  //console.log(api_url);
  var Httpreq = new XMLHttpRequest();
  Httpreq.open("GET", api_url, false);
  Httpreq.send(null);
  var response_obj = JSON.parse(Httpreq.responseText)['results'];
  //console.dir(response_obj);
  var ken = response_obj[0]['address1'];
  //console.log(ken);
  return ken;
}


function getKenId(ken, what_type){
  let ken_id = '';
  if(what_type==='介援隊'){
    let ken_array = ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県'];
    let index = ken_array.indexOf(ken)+1;
    ken_id = String(index);
  }

  return ken_id;
}





function checkHattyuuSuu(cm_data_obj, dataArray){
  let this_id = cm_data_obj.id;
  let isit_add = false;
  let howmany = 0;
  for (let i = 0; i < dataArray.length; i++) {
    //if(this_id===dataArray[i].id && dataArray[i].hattyuu_howmany>0){
    if(this_id===dataArray[i].id){ // 発注した数 0 入ると次のに引当たらない
      isit_add=true;
      howmany = dataArray[i].hattyuu_howmany;
      break;
    }
  }
  return [isit_add, howmany];
}

function checkHikiateSuu(cm_data_obj, dataArray){
  let this_id = cm_data_obj.id;
  let isit_add = false;
  let howmany = 0;
  for (let i = 0; i < dataArray.length; i++) {
    //if(this_id===dataArray[i].id && dataArray[i].hattyuu_howmany>0){
    if(this_id===dataArray[i].id){ // 発注した数 0 入ると次のに引当たらない
      isit_add=true;
      //howmany = dataArray[i].hikiate_howmany; // 全部出荷チャックしても、引き当て０はみカウントで未チェックになってややこしい
      howmany = dataArray[i].hattyuu_zumi;
      break;
    }
  }
  return [isit_add, howmany];
}






class FunctionFields {

  changeFinishData(cm_order_no, auth_obj){
    let api_url = settings.API_BASE_URL + 'order_change_finish/' + '?token=' + auth_obj.token + '&name='+ auth_obj.name +'&cm_order_no=' + cm_order_no;
    var Httpreq = new XMLHttpRequest();
    Httpreq.open("PUT", api_url, false);
    Httpreq.send(null);
    var response_obj = JSON.parse(Httpreq.responseText)['data'];
    return response_obj.data;
  }


  getCancelData(this_tonya, auth_obj){
    let api_url = settings.API_BASE_URL + 'get_cancel_list/' + '?token=' + auth_obj.token + '&name='+ auth_obj.name +'&tonya_name_f=' + this_tonya;
    //console.log(api_url);
    var Httpreq = new XMLHttpRequest();
    Httpreq.open("GET", api_url, false);
    Httpreq.send(null);
    var response_obj = JSON.parse(Httpreq.responseText)['data'];
    //console.dir(response_obj.obj);
    return response_obj.obj;

  }




  createTableData(tonya_id, headers, data){
    console.log(tonya_id);
    console.dir(headers);
    console.dir(data);

    let re_array = [];

    if(tonya_id===24){ //マルク
      re_array = [[{ value: 'JAN' }, { value: '数量'}]];
      for (let i = 0; i < data.length; i++) {
        let _jan = data[i][0];
        let _howmany = data[i][1];
        re_array.push([{ value: _jan }, { value: _howmany}]);
      }
    }
    else if(tonya_id===3){ //アサヒシューず
      let re_array_child = [];
      for (let i = 0; i < headers.length; i++) {
        for (const [key, value] of Object.entries(headers[i])) {
          console.log(key, value);
          if(key==='header'){
            re_array_child.push({ value: value });
          }
        }
      }

      re_array = [re_array_child];

      for (let i = 0; i < data.length; i++) {
        let cm_order_no = data[i][0];
        let _jan = data[i][1];
        let _item_type = data[i][2];
        let _color = data[i][3];
        let _size = data[i][4];
        let _howmany = data[i][5];
        re_array.push([{ value: cm_order_no }, { value: _jan},  { value: _item_type}, { value: _color}, { value: _size}, { value: _howmany}]);
      }
    }
    else if(tonya_id===37){ //アサヒサイクル
      let re_array_child = [];
      for (let i = 0; i < headers.length; i++) {
        for (const [key, value] of Object.entries(headers[i])) {
          console.log(key, value);
          if(key==='header'){
            re_array_child.push({ value: value });
          }
        }
      }

      re_array = [re_array_child];

      for (let i = 0; i < data.length; i++) {
        let f_name = data[i][0];
        let cm_order_no = data[i][1];
        let _jan = data[i][2];
        let _item_type = data[i][3];
        let _color = data[i][4];
        let _size = data[i][5];
        let _howmany = data[i][6];
        re_array.push([{ value: f_name }, { value: cm_order_no }, { value: _jan},  { value: _item_type}, { value: _color}, { value: _size}, { value: _howmany}]);
      }
    }
    else if(tonya_id===23){ //三共
      let re_array_child = [];
      for (let i = 0; i < headers.length; i++) {
        for (const [key, value] of Object.entries(headers[i])) {
          console.log(key, value);
          if(key==='header'){
            re_array_child.push({ value: value });
          }
        }
      }

      re_array = [re_array_child];

      for (let i = 0; i < data.length; i++) {
        let cm_order_no = data[i][0];
        let meisai_gyou = data[i][1];
        let _jan = data[i][2];
        let _color = data[i][3];
        let _size = data[i][4];
        let _howmany = data[i][5];
        re_array.push([{ value: cm_order_no }, { value: meisai_gyou }, { value: _jan}, { value: _color}, { value: _size}, { value: _howmany}]);
      }
    }
    else if(tonya_id===8 || tonya_id===48 || tonya_id===109 || tonya_id===108){ //ナビリオン
      let re_array_child = [];
      for (let i = 0; i < headers.length; i++) {
        for (const [key, value] of Object.entries(headers[i])) {
          console.log(key, value);
          if(key==='header'){
            re_array_child.push({ value: value });
          }
        }
      }

      re_array = [re_array_child];

      for (let i = 0; i < data.length; i++) {
        let f_name = data[i][0];
        let cm_order_no = data[i][1];
        let _jan = data[i][2];
        let _item_type = data[i][3];
        let _color = data[i][4];
        let _size = data[i][5];
        let _howmany = data[i][6];
        re_array.push([{ value: f_name }, { value: cm_order_no }, { value: _jan},  { value: _item_type}, { value: _color}, { value: _size}, { value: _howmany}]);
      }
    }else if(tonya_id===101 || tonya_id===102 || tonya_id===103 || tonya_id===111 || tonya_id===105 || tonya_id===106){ // 単品特価
      let re_array_child = [];
      for (let i = 0; i < headers.length; i++) {
        for (const [key, value] of Object.entries(headers[i])) {
          console.log(key, value);
          if(key==='header'){
            re_array_child.push({ value: value });
          }
        }
      }

      console.dir(re_array_child);
      re_array = [re_array_child];

      for (let i = 0; i < data.length; i++) {
        let tonya_name_f = data[i][0];
        let cm_order_no = data[i][1];
        let meisai_gyou = data[i][2];
        let _jan = data[i][3];
        let _item_type = data[i][4];
        let _color = data[i][5];
        let _size = data[i][6];
        let item_url = data[i][7];
        let _howmany = data[i][8];
        re_array.push([{ value: tonya_name_f }, { value: cm_order_no }, { value: meisai_gyou }, { value: _jan}, { value: _item_type}, { value: _color}, { value: _size}, { value: item_url}, { value: _howmany}]);
      }
    }

    console.dir(re_array);
    
    return re_array;
  }




  board2Soart(tonya_obj_array){
    //let _array = [];
    //for (let i = 0; i < tonya_obj_array.length; i++) {
    //  _array.push({id:tonya_obj_array[i].id, zan:tonya_obj_array[i].hattyuu_zan});
    //}

    tonya_obj_array.sort((a, b) => a.syukka_check_zan > b.syukka_check_zan ? -1 : 1);
    //console.dir(tonya_obj_array);
    return tonya_obj_array;
  }


  boardSoart(tonya_obj_array, tonya_obj_array_id_fix){
    let re_array = [];
    for (let i = 0; i < tonya_obj_array_id_fix.length; i++) {
      for (let ii = 0; ii < tonya_obj_array.length; ii++) {
        if(tonya_obj_array_id_fix[i]===tonya_obj_array[ii].id){
          re_array.push(tonya_obj_array[ii]);
          break;
        }
      }
    }

    return re_array ;
  }





  getFileHeader(tonya_id){
    let header_array = [];
    if(tonya_id===27 || tonya_id===24 || tonya_id===116){ // メトロ,　マルク
      header_array.push({colum:'JAN', key:'JAN'});
      header_array.push({colum:'発注数', key:'hattyuu_howmany'});
    }else if(tonya_id===12 || tonya_id===13 || tonya_id===14 || tonya_id===15){ // SSK
      header_array.push({header:'JAN(必須)', key:'JAN'});
      header_array.push({header:'数量(必須)', key:'hattyuu_howmany'});
      header_array.push({header:'コメント(任意)', key:'order_key'});
      header_array.push({header:'チーム名ｶﾅ(任意)', key:'team_name'});
      header_array.push({header:'引き当て倉庫区分(必須)', key:'warehouse'});
    }else if(tonya_id===53 || tonya_id===34){ // ZETT
      header_array.push({colum:'JAN', key:'JAN'});
      header_array.push({colum:'発注数', key:'hattyuu_howmany'});
      header_array.push({colum:'KEY', key:'order_key'});
    }else if(tonya_id===41 || tonya_id===1 || tonya_id===5 || tonya_id===6 || tonya_id===7 || tonya_id===10 || tonya_id===32 || tonya_id===40){ // KONGS, 西海, マルモト, モリシタ, NETde, トップ, 鈴市、ペット
      header_array.push({header:'品番', key:'JAN'});
      header_array.push({header:'注文数', key:'hattyuu_howmany'});
    }else if(tonya_id===29){ //テイクハート
      header_array.push({header:'商品コード', key:'JAN'});
      header_array.push({header:'数量', key:'hattyuu_howmany'});
    }else if(tonya_id===33){ //野口
      header_array.push({header:'商品コード', key:'item_type'});
      header_array.push({header:'JANコード', key:'JAN'});
      header_array.push({header:'商品名', key:''});
      header_array.push({header:'カラー', key:''});
      header_array.push({header:'注文数', key:'hattyuu_howmany'});
    }else if(tonya_id===31){ //阿部玩具
      header_array.push({header:'', key:''});
      header_array.push({header:'JANコード', key:'JAN'});
      header_array.push({header:'品名', key:'item_name'});
      header_array.push({header:'注文数', key:'hattyuu_howmany'});
      header_array.push({header:'備考', key:'order_key'});
      header_array.push({header:'引当数量', key:''});
      header_array.push({header:'掛率', key:''});
    }else if(tonya_id===3){ // アサヒシューズ
      header_array.push({header:'伝票番号', key:'cm_order_no'});
      header_array.push({header:'JAN', key:'JAN'});
      header_array.push({header:'型番', key:'item_type'});
      header_array.push({header:'色', key:'color'});
      header_array.push({header:'サイズ', key:'size'});
      header_array.push({header:'集計', key:'hattyuu_howmany'});
    }else if(tonya_id===37){ // アサヒサイクル
      header_array.push({header:'ファイル名', key:'which_tonya'});
      header_array.push({header:'伝票番号', key:'cm_order_no'});
      header_array.push({header:'型番', key:'JAN'});
      header_array.push({header:'型番2', key:'item_type'});
      header_array.push({header:'色', key:'color'});
      header_array.push({header:'サイズ', key:'size'});
      header_array.push({header:'集計', key:'hattyuu_howmany'});
    }else if(tonya_id===8 || tonya_id===48 || tonya_id===109 || tonya_id===108){ // ナビリオン
      header_array.push({header:'ファイル名', key:'which_tonya'});
      header_array.push({header:'伝票番号', key:'cm_order_no'});
      header_array.push({header:'型番', key:'JAN'});
      header_array.push({header:'型番2', key:'item_type'});
      header_array.push({header:'色', key:'color'});
      header_array.push({header:'サイズ', key:'size'});
      header_array.push({header:'集計', key:'hattyuu_howmany'});
    }else if(tonya_id===23){ // 三共
      header_array.push({header:'伝票番号', key:'cm_order_no'});
      header_array.push({header:'明細行', key:'meisai_gyou'});
      header_array.push({header:'JAN', key:'JAN'});
      header_array.push({header:'色', key:'color'});
      header_array.push({header:'サイズ', key:'size'});
      header_array.push({header:'集計', key:'hattyuu_howmany'});
    }else if(tonya_id===38){ // エトワール
      header_array.push({header:'類番(上３桁)', key:'col_1'});
      header_array.push({header:'類番(下３桁)', key:'col_2'});
      header_array.push({header:'カラー', key:'col_3'});
      header_array.push({header:'サイズ', key:'col_4'});
      header_array.push({header:'類品番登録日', key:''});
      header_array.push({header:'注文数(束数)', key:'hattyuu_howmany'});
    }else if(tonya_id===20 || tonya_id===55 || tonya_id===117){ // XANAX 普通, メーカー
      header_array.push({colum:'id', key:''});
      header_array.push({colum:'col_2', key:''});
      header_array.push({colum:'KEY', key:'order_key'});
      header_array.push({colum:'col_3', key:''});
      header_array.push({colum:'col_4', key:''});
      header_array.push({colum:'JAN', key:'JAN'});
      header_array.push({colum:'発注数', key:'hattyuu_howmany'}); 
    }else if(tonya_id===101 || tonya_id===102 || tonya_id===103 || tonya_id===111 || tonya_id===105 || tonya_id===106){ // 単品特価
      header_array.push({header:'ファイル名', key:'which_tonya'});
      header_array.push({header:'伝票番号', key:'cm_order_no'});
      header_array.push({header:'明細行', key:'meisai_gyou'});
      header_array.push({header:'型番', key:'JAN'});
      header_array.push({header:'型番2', key:'item_type'});
      header_array.push({header:'色', key:'color'});
      header_array.push({header:'サイズ', key:'size'});
      header_array.push({header:'備考', key:'memo'});
      header_array.push({header:'集計', key:'hattyuu_howmany'});
    }else if(tonya_id===43 || tonya_id===50){ // アピデ
      header_array.push({header:'お届け時間帯', key:''});
      header_array.push({header:'ＥＣ注文番号', key:'order_key'});
      header_array.push({header:'商品管理番号', key:'item_type_0'});
      header_array.push({header:'商品番号', key:'item_type'});
      header_array.push({header:'数量', key:'hattyuu_howmany'});
      header_array.push({header:'注文備考', key:''});
      header_array.push({header:'商品名', key:''});
      header_array.push({header:'ボックス個数', key:''});
      header_array.push({header:'送付先コード', key:''});
      header_array.push({header:'送付先郵便番号', key:''});
      header_array.push({header:'送付先都道府県', key:''});
      header_array.push({header:'送付先住所１', key:''});
      header_array.push({header:'送付先住所２', key:''});
      header_array.push({header:'送付先会社名', key:''});
      header_array.push({header:'送付先部署名', key:''});
      header_array.push({header:'送付先お名前', key:''});
      header_array.push({header:'送付先お名前カナ', key:''});
      header_array.push({header:'送付先電話番号', key:''});
      header_array.push({header:'送付先ＦＡＸ番号', key:''});
      header_array.push({header:'お届け日', key:''});
      header_array.push({header:'送り主郵便番号', key:''});
      header_array.push({header:'送り主都道府県', key:''});
      header_array.push({header:'送り主住所１', key:''});
      header_array.push({header:'送り主住所２', key:''});
      header_array.push({header:'送り主会社名', key:''});
      header_array.push({header:'送り主お名前', key:''});
      header_array.push({header:'送り主お名前カナ', key:''});
      header_array.push({header:'送り主電話番号', key:''});
      
    }else if(tonya_id===42){ // 介援隊
      header_array.push({colum:'送付先郵便番号', key:''});
      header_array.push({colum:'送付先お名前', key:''});
      header_array.push({colum:'space', key:''});
      header_array.push({colum:'都道府県コード', key:''});
      header_array.push({colum:'送付先住所１', key:''});
      header_array.push({colum:'space', key:''});
      header_array.push({colum:'送付先電話番号', key:''});
      header_array.push({colum:'注文者名', key:''});
      header_array.push({colum:'space', key:''});
      header_array.push({colum:'space', key:''});
      header_array.push({colum:'space', key:''});
      header_array.push({colum:'space', key:''});
      header_array.push({colum:'space', key:''});
      header_array.push({colum:'JAN', key:'JAN'});
      header_array.push({colum:'発注数', key:'hattyuu_howmany'}); 
      header_array.push({colum:'KEY', key:'order_key'});
      header_array.push({colum:'管理番号', key:'cm_order_no'});
    }


    return header_array;
  }


  getFileData(headers, tonya_id, tonya_name_f, props_obj, row_status, formData){
    console.dir(props_obj);
    let data_array = [];
    let array_child = [];
    let cm_datas =props_obj.cm_datas;
    let dataArray =props_obj.dataArray;

    // obj JANでソート
    //cm_datas = cm_datas.sort(function(a, b) {
    //  return (a.JAN < b.JAN) ? -1 : 1;  //オブジェクトの昇順ソート
    //});
    dataArray = dataArray.sort(function(a, b) {
      return (a.JAN < b.JAN) ? -1 : 1;  //オブジェクトの昇順ソート
    });

    //数を先にまとめるべし, KEYを記載する場合はまとめない
    //let write_key_tonya_id_array = [12,13,14,15,20, 31,  34, 42, 53, 54, 55, 101, 102, 103, 111, 105, 106]; //KEY記載する問屋リスト, JANをまとめない, CMList.js内にも
    let write_key_tonya_id_array = settings.NO_COUNT_SAME_JAN_TONYA_IDs;
    
    let count_check_obj = {};
    let re_array = [];
    for (let i = 0; i < dataArray.length; i++) {
      let this_jan = dataArray[i].JAN;

      if(props_obj.formDataCutHattyuu.includes(dataArray[i].id)){
        continue;
      }

      let hattyuu_howmany = 0;
      if(dataArray[i].cm_item_name.indexOf('予約注文___') !== -1){
      //if(cm_datas[i].cm_item_name.indexOf('予約注文___') !== -1 && formData.includes(cm_datas[i].id)){
        hattyuu_howmany = dataArray[i].hattyuu_zumi - dataArray[i].hikiate_howmany;
      }else if(dataArray[i].which_tonya===tonya_name_f){
        hattyuu_howmany = dataArray[i].hattyuu_howmany;
      }

      if(this_jan in count_check_obj){
        count_check_obj[this_jan] = count_check_obj[this_jan] + hattyuu_howmany;
      }else{
        count_check_obj[this_jan] = hattyuu_howmany;
      }
    }
    
    console.dir(count_check_obj);

    let checked_jan = [];
    let hattyuu_howmany = 0;
    for (let i = 0; i < dataArray.length; i++) {
      if(dataArray[i].which_tonya===tonya_name_f && dataArray[i].hattyuu_status_now===row_status){
        let this_jan = dataArray[i].JAN;

        if (checked_jan.includes(this_jan)===true && write_key_tonya_id_array.includes(tonya_id)===false) {
          console.log("PASS " + this_jan);
          continue;
        }

        if(props_obj.formDataCutHattyuu.includes(dataArray[i].id)){
          continue;
        }


        //let hattyuu_howmany = cm_datas[i].hattyuu_howmany;
        if(write_key_tonya_id_array.includes(tonya_id)===false){
          hattyuu_howmany = count_check_obj[this_jan];
        }else{
          if(dataArray[i].cm_item_name.indexOf('予約注文___') !== -1){
            hattyuu_howmany = dataArray[i].hattyuu_zumi;
          }else{
            hattyuu_howmany = dataArray[i].hattyuu_howmany;
          }
        }
        

        let order_key = dataArray[i].order_key;
        let item_type = dataArray[i].item_type;
        let tonya_item_name = dataArray[i].tonya_item_name;
        let post_code = dataArray[i].cm_customer_post;
        let ship_name = dataArray[i].cm_ship_name;
        let cm_customer_name = dataArray[i].cm_customer_name;
        let cm_order_no = dataArray[i].cm_order_no;
        let color = dataArray[i].color_type;
        let size= dataArray[i].size_type;
        let item_url = dataArray[i].item_url;
        let meisai_gyou = dataArray[i].meisai_gyou;

        let a_1 = dataArray[i].cm_customer_address;
        let a_2 = dataArray[i].cm_customer_address_2;
        let phone = dataArray[i].cm_phone;

        let delivery = dataArray[i].delivery;
        let payment = dataArray[i].payment;

        if(hattyuu_howmany<=0){
          console.log('発注数0以下 '+this_jan+' '+order_key);
          continue;
        }

        try{
          if(a_1.length>2){
            //if(a_1.slice(0,2)==='国外' || delivery==='ヤマト コレクト（代引）'){
            if(a_1.slice(0,2)==='国外' || payment==='代金引換'){
              post_code = '452-0034';
              ship_name = '株式会社リプレイス';
              //ken_id = '23';
              a_1 = '愛知県清須市西枇杷島町日之出1-2';
              a_2 = '';
              phone = '07083326359';
              cm_customer_name = '株式会社リプレイス　ポッチ';
            }
          }
        }catch(e){
          console.log(e);
          // st などの場合
        }





        if(tonya_id===42){ // 介援隊
          post_code = post_code.replace('-', '');
          if(cm_customer_name===undefined || cm_customer_name==='' ){
            cm_customer_name = '株式会社リプレイス　ポッチ';
          }
          //console.log('cm_customer_name '+cm_customer_name);

          let ken = '';
          try{
            ken = convertZipKen(post_code);
          }catch (error) {
            console.log('県名取得できませんでした '+String(post_code)+' order_key:'+String(order_key));
          }
          
          let ken_id = getKenId(ken, '介援隊');

          array_child = [post_code, ship_name, '', ken_id, a_1+a_2, '', phone, cm_customer_name, '', '', '', '', '', this_jan, hattyuu_howmany, cm_order_no, order_key ];

        }
        else if(tonya_id===27 || tonya_id===116){//メトロ
          while (true) {
            if(this_jan[0]==='0'){
              this_jan = this_jan.slice(1);
            }else{
              break;
            }
          }
          array_child = [this_jan, hattyuu_howmany];
        }
        else if(tonya_id===3){ //アサヒシューズ 
          array_child = [cm_order_no, this_jan, item_type, color, size, hattyuu_howmany];
        }
        else if(tonya_id===37){ //アサヒサイクル
          array_child = [dataArray[i].which_tonya, cm_order_no, this_jan, item_type, color, size, hattyuu_howmany];
        }
        else if(tonya_id===8 || tonya_id===48 || tonya_id===109 || tonya_id===108){ //ナビリオン
          array_child = [dataArray[i].which_tonya, cm_order_no, this_jan, item_type, color, size, hattyuu_howmany];
        }
        else if(tonya_id===23){ //三共
          array_child = [cm_order_no, meisai_gyou, this_jan, color, size, hattyuu_howmany];
        }
        else if(tonya_id===24){ //マルク
          array_child = [this_jan, hattyuu_howmany];
        }else if(tonya_id===12 || tonya_id===13 || tonya_id===14 || tonya_id===15){//SSK
          array_child = [this_jan, hattyuu_howmany, order_key, '', 1];
        }else if(tonya_id===53 || tonya_id===34){ // ZETT
          array_child = [this_jan, hattyuu_howmany, order_key];
        }else if(tonya_id===41 || tonya_id===6 || tonya_id===32 || tonya_id===29 || tonya_id===40){ // KONGS, マルモト, 鈴市, テイクハート, ペット
          if(tonya_id===32){
            while (true) {
              if(this_jan[0]==='0'){
                this_jan = this_jan.slice(1);
              }else{
                break;
              }
            }
          }
          array_child = [this_jan, hattyuu_howmany];
        }else if(tonya_id===1 || tonya_id===5 || tonya_id===7 || tonya_id===10){ // 西海, モリシタ, NETde, トップ
          array_child = [item_type, hattyuu_howmany];
        }else if(tonya_id===43 || tonya_id===50){ // アビデ
          let ken = '';
          try{
            ken = convertZipKen(post_code);
          }catch (error) {
            console.log('県名取得できませんでした '+String(post_code)+' order_key:'+String(order_key));
          }

          if(a_1.indexOf(ken)!==-1){
            a_1 = a_1.replace(ken, '');
          }

          array_child = ['', order_key, '', item_type, hattyuu_howmany, '', tonya_item_name,'', '', post_code, ken, a_1, a_2, '', '', ship_name, '', phone, '', '', '452-0034', '愛知県', '清須市西枇杷島町', '日之出1-2', '代行:株式会社リミックス', '株式会社リミックス', '', '075-861-2911'];
        }else if(tonya_id===38){ // エトワール
          let item_type_array = item_type.split(' ');
          let col_1_array  = item_type_array[0].split('-'); 
          let col_2_array  = item_type_array[1].split('-'); 
          array_child = [col_1_array[0], col_1_array[1], col_2_array[0], col_2_array[1], '', hattyuu_howmany, '','','','','','','',''];
        }else if(tonya_id===33){ //野口
          array_child = [item_type, this_jan, '', '', hattyuu_howmany];
        }else if(tonya_id===31){ //阿部玩具
          array_child = ['', this_jan, tonya_item_name, hattyuu_howmany, order_key, '', ''];
        }else if(tonya_id===20 || tonya_id===55 || tonya_id===117){ // XANAX 普通、メーカー
          array_child = ['626901', '', order_key, '', '', this_jan, hattyuu_howmany];
        }else if(tonya_id===101 || tonya_id===102 || tonya_id===103 || tonya_id===111 || tonya_id===105 || tonya_id===106){ // 単品特価
          array_child = [tonya_name_f, cm_order_no, meisai_gyou, this_jan, item_type, color, size, item_url, hattyuu_howmany]
        
        }

        
        data_array.push(array_child);

        checked_jan.push(this_jan);
      }
    }

    console.dir(data_array);

    // JAN並び順から管理番号順に戻す, 全てではない
    if(tonya_id===42){
      data_array.sort(function(a,b){return(Number(a[15]) - Number(b[15]));});
    }
    else if(tonya_id===27){

    }else if(tonya_id===3 || tonya_id===23){
      data_array.sort(function(a,b){return(Number(a[0]) - Number(b[0]));});

    }else if(tonya_id===8 || tonya_id===48 || tonya_id===37 || tonya_id===101 || tonya_id===102 || tonya_id===103 || tonya_id===111 || tonya_id===105 || tonya_id===106){
      data_array.sort(function(a,b){return(Number(a[1]) - Number(b[1]));});

    }else if(tonya_id===12 || tonya_id===13 || tonya_id===14 || tonya_id===15 || tonya_id===53 || tonya_id===34){
      data_array.sort(function(a,b){return(Number(a[2]) - Number(b[2]));});

    }else if(tonya_id===43){
      data_array.sort(function(a,b){return(Number(a[0].slice(0,8)) - Number(b[0].slice(0,8)));});

    }else if(tonya_id===31){
      data_array.sort(function(a,b){return(Number(a[4].slice(0,8)) - Number(b[4].slice(0,8)));});

    }else if(tonya_id===20 || tonya_id===55 || tonya_id===117){
      data_array.sort(function(a,b){return(Number(a[2].slice(0,8)) - Number(b[2].slice(0,8)));});

    }

    
    console.dir(data_array);


    return data_array;
  }



  getDammyData(){
    let dammy_data = [
      ['', '処理日', '処理時間', '処理日・時間', '社員番号', '顧客番号', '','','','','','','品番','品番登録年月日'],
      ['SCAN', '20211026', '105610', '20211026-105610', '14000502', '649667', '','','','','','','',''],
      ['類番(上３桁)', '類番(下３桁)', 'カラー', 'サイズ', '類品番登録日', '注文数(束数)', '','','','','','','',''],
      ['548', '021', '00', '03', '', '5','','','','','','','548307','20170526']
    ];
    let i = 0;
    while(i<35){
      dammy_data.push(['','','','','','','','','','','','','','']);

      i+=1
    }

    return dammy_data;
  }

  addEtoileHeader(data){
    // 順番逆にしてる、後で足すので
    let dammy_data = [
      ['類番(上３桁)', '類番(下３桁)', 'カラー', 'サイズ', '類品番登録日', '注文数(束数)', '','','','','','','',''],
      ['SCAN', '20211026', '105610', '20211026-105610', '14000502', '649667', '','','','','','','',''],
      ['', '処理日', '処理時間', '処理日・時間', '社員番号', '顧客番号', '','','','','','','品番','品番登録年月日']
    ];

    for (let i = 0; i < dammy_data.length; i++) {
      data.unshift(dammy_data[i]);
    }

    console.dir(data);
    return data;
  }



  addFomula(what_type, worksheet, how_row){
    let i = 0;

    let background_color_obj = {type: 'pattern', pattern: 'solid', fgColor: { argb: 'FADDCD' }};

    while(i<how_row){
      let cell_k = worksheet.getCell('K'+String(i+2));
      cell_k.value = { formula: '=A'+String(i+4)+'&B'+String(i+4) };

      let cell_L = worksheet.getCell('L'+String(i+2));
      cell_L.value = { formula: '=VLOOKUP(K'+String(i+2)+',$M$1:$N$355,2,FALSE)' };

      let cell_E = worksheet.getCell('E'+String(i+4));
      cell_E.value = { formula: '=VLOOKUP(K'+String(i+2)+',$M$1:$N$355,2,FALSE)' };

      if(what_type==='dammy'){
        worksheet.getCell('A'+String(i+4)).fill = background_color_obj;
        worksheet.getCell('B'+String(i+4)).fill = background_color_obj;
        worksheet.getCell('C'+String(i+4)).fill = background_color_obj;
        worksheet.getCell('D'+String(i+4)).fill = background_color_obj;
        worksheet.getCell('F'+String(i+4)).fill = background_color_obj;
      }

      i+=1

    }

    worksheet.getRow(1).height = 1;
    worksheet.getRow(2).height = 1;
    worksheet.getColumn(11).width = 0;
    worksheet.getColumn(12).width = 0;
    worksheet.getColumn(13).width = 0;
    worksheet.getColumn(14).width = 0;

    return worksheet
  }



  convertHattyuuYoubi(row_obj){
    //let order_frequency_array = row_obj.order_frequency.split(',');
    //let hattyuu_youbi_str = '';
    //for (let i = 0; i < order_frequency_array.length; i++) {
    //  order_frequency_array[i]
    //}
    let hattyuu_youbi_str = row_obj.order_frequency;
    if(hattyuu_youbi_str==='0,1,2,3,4,5,6'){
      hattyuu_youbi_str = '毎日';
    }else{
      hattyuu_youbi_str = hattyuu_youbi_str.replace('0','月');
      hattyuu_youbi_str = hattyuu_youbi_str.replace('1','火');
      hattyuu_youbi_str = hattyuu_youbi_str.replace('2','水');
      hattyuu_youbi_str = hattyuu_youbi_str.replace('3','木');
      hattyuu_youbi_str = hattyuu_youbi_str.replace('4','金');
      hattyuu_youbi_str = hattyuu_youbi_str.replace('5','土');
      hattyuu_youbi_str = hattyuu_youbi_str.replace('6','日');
    }

    return hattyuu_youbi_str;

  }


  converDate(row_obj, what_type){
    //console.log(what_type);
    //console.log(row_obj.hattyuu_checker);
    let date_str = '';
    if(what_type==='hattyuu'){
      date_str = row_obj.hattyuu_checker;
    }else if(what_type==='syukka'){
      date_str = row_obj.shipment_checker;
    }
    
    date_str = date_str.slice(5);
    date_str = date_str.slice(0,-3);
    date_str = date_str.replace('-', '/');
    date_str = date_str.replace('T', ' ');
    let parts = date_str.split('/');
    if(parts[0].charAt(0)==='0'){
      parts[0] = parts[0].substring(1);
    }
    if(parts[1].charAt(0)==='0'){
      parts[1] = parts[1].substring(1);
    }
    date_str = parts[0] + '/' + parts[1];
    //console.log(date_str);

    return date_str;
  }

  converDeadLineDate(row_obj){
    let deadline = String(row_obj.shipping_date_2);
    if(deadline.indexOf('.') !== -1){
      deadline = deadline.replace('.', ':');
    }else{
      deadline = deadline+':00';
    }

    if(deadline==='12:3'){
      deadline = '12:30';
    }

    return deadline;
  }


  convertTonyaArray(tonya_obj_array){
    let today = new Date();
    let today_no = today.getDay()-1; // 今日の曜日

    let re_array_1 = [];
    let re_array_2 = [];
    for (let i = 0; i < tonya_obj_array.length; i++) {
      if(tonya_obj_array[i].order_frequency.indexOf(today_no) !== -1){
        re_array_1.push(tonya_obj_array[i]);
      }else{
        re_array_2.push(tonya_obj_array[i]);
      }
    }

    let re_tonya_obj_array = re_array_1.concat(re_array_2);

    return re_tonya_obj_array;

  }



  updateHattyuuDate(this_obj, auth_obj){
    let tonya_id = this_obj.dataset.dbId;
    
    let api_url = settings.API_BASE_URL + 'update_hattyuu_owari/' + '?token=' + auth_obj.token + '&name='+ auth_obj.name +'&tonya_id=' + tonya_id
    var Httpreq = new XMLHttpRequest();
    Httpreq.open("PUT", api_url, false);
    Httpreq.send(null);
    var response_obj = JSON.parse(Httpreq.responseText)['data'];
    return response_obj.data;

  }


  updateSyukaKakuninDate(this_obj, auth_obj){
    let tonya_id = this_obj.dataset.dbId;
    console.log(tonya_id );

    let api_url = settings.API_BASE_URL + 'update_syukka_owari/' + '?token=' + auth_obj.token + '&name='+ auth_obj.name +'&tonya_id=' + tonya_id
    var Httpreq = new XMLHttpRequest();
    Httpreq.open("PUT", api_url, false);
    Httpreq.send(null);
    var response_obj = JSON.parse(Httpreq.responseText)['data'];
    return response_obj.data;
  }


  getJanList(this_tonya, auth_obj){
    let data_array = [];

    let api_url = settings.API_BASE_URL + 'get_jan_list/' + '?token=' + auth_obj.token + '&name='+ auth_obj.name +'&tonya_name_f=' + this_tonya
    var Httpreq = new XMLHttpRequest();
    Httpreq.open("GET", api_url, false);
    Httpreq.send(null);
    var response_obj = JSON.parse(Httpreq.responseText)['data'];
    console.dir(response_obj.obj);
    return response_obj.obj;

  }




  updateCmOrderHattyuu(this_obj, auth_obj, props_obj){
    let tonya_id = Number(this_obj.dataset.dbId);
    let checked_tonya_name = '';
    for (let i = 0; i < props_obj.tonya_datas.length; i++) {
      if(props_obj.tonya_datas[i].id===tonya_id){
        checked_tonya_name = props_obj.tonya_datas[i].tonya_name_f;
        break;
      }
    }
    console.log('checked_tonya_name '+checked_tonya_name);

    let _elm = document.getElementById('checkbox_1_'+String(tonya_id));

    if(checked_tonya_name!==props_obj.table_tonya_label){
      let alert_box = window.confirm('チェックした問屋：'+checked_tonya_name+'\n下の表の問屋：'+props_obj.table_tonya_label+'\n 処理を進めてもいいですか？\n（発注済みにチェック）');
      if(alert_box===false){
        _elm.innerHTML = '';
        return 'check_false';
      }
    }

    let post_array = [];
    let howmany_hattyuu = 0;
    let isit_add = false;
    let this_howmany = 0;
    for (let i = 0; i < props_obj.cm_datas.length; i++) {
      if(
        props_obj.cm_datas[i].which_tonya===checked_tonya_name && 
        props_obj.cm_datas[i].hattyuu_status_now==='未発注' && 
        props_obj.formDataCutHattyuu.includes(props_obj.cm_datas[i].id)===false
      ){
        let res_array = checkHattyuuSuu(props_obj.cm_datas[i], props_obj.dataArray);
        isit_add = res_array[0];
        this_howmany = res_array[1];
        if(isit_add===true){
          post_array.push(props_obj.cm_datas[i]);
          howmany_hattyuu = howmany_hattyuu + this_howmany;
        }
        

        //if(props_obj.cm_datas[i].hattyuu_howmany>0){
        //  howmany_hattyuu++;
        //}
      }
    }
    console.log('how many post_array '+String(post_array.length));
    console.log('howmany_hattyuu '+String(howmany_hattyuu));
    console.dir(post_array);
    
    if(post_array.length>0){
      fetch(settings.API_BASE_URL+'hattyuu/' + '?token=' + auth_obj.token + '&name='+ auth_obj.name , {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({"data":post_array})
      })
      .then(response => response.json())
      .then(data => {
        console.dir(data.data.result);
        _elm.innerHTML = '';

        if(data.data.result==='zaiko_torikomi_runnning'){
          alert('今在庫データ取り込み中です.\n今のチェック内容は記録されていません.\n後ほどリトライお願いします！');
        }
      })
      .catch(error => {
        console.error(error)
        _elm.innerHTML = '';
        alert(error);
      });

    }else{
      _elm.innerHTML = '';
    }


    console.log(tonya_id);
    console.dir(props_obj);
    return howmany_hattyuu;
  }




  updateCmOrderSyukka(this_obj, auth_obj, props_obj){
    let tonya_id = Number(this_obj.dataset.dbId);
    let checked_tonya_name = '';
    for (let i = 0; i < props_obj.tonya_datas.length; i++) {
      if(props_obj.tonya_datas[i].id===tonya_id){
        checked_tonya_name = props_obj.tonya_datas[i].tonya_name_f;
        break;
      }
    }
    console.log('checked_tonya_name '+checked_tonya_name);
    console.dir(props_obj.formData);
    let _elm = document.getElementById('checkbox_2_'+String(tonya_id));

    if(checked_tonya_name!==props_obj.table_tonya_label){
      let alert_box = window.confirm('チェックした問屋：'+checked_tonya_name+'\n下の表の問屋：'+props_obj.table_tonya_label+'\n 処理を進めてもいいですか？\n（発注済みにチェック）\n件数：'+String(props_obj.formData.length));
      if(alert_box===false){
        _elm.innerHTML = '';
        return 'check_false';
      }
    }else{
      let alert_box = window.confirm('出荷確認する問屋さん：'+props_obj.table_tonya_label+'\n件数：'+String(props_obj.formData.length)+'\n処理を進めてもいいですか？ ');
      if(alert_box===false){
        _elm.innerHTML = '';
        return 'check_false';
      }
    }


    let todayDate = new Date();
    let today_str = todayDate.getFullYear() + '-' + (todayDate.getMonth()+1).toString().padStart(2, '0') + '-' + todayDate.getDate().toString().padStart(2, '0') ;

    let post_array = [];
    let hikiate_post_ids = [];
    let hikiate_howmany = 0;
    let isit_add = false;
    let this_howmany = 0;
    let change_count = 0;
    let stop = false;
    let isit_alert = false;
    for (let i = 0; i < props_obj.cm_datas.length; i++) {

      console.dir(props_obj.formData);
      console.dir(props_obj.cm_datas[i]);
      console.log(checked_tonya_name);

      if(
        props_obj.cm_datas[i].which_tonya===checked_tonya_name && 
        props_obj.cm_datas[i].hattyuu_status_now==='発注済' && 
        (props_obj.formData.includes(props_obj.cm_datas[i].id))
      ){
        let res_array = checkHikiateSuu(props_obj.cm_datas[i], props_obj.dataArray);
        isit_add = res_array[0];
        this_howmany = res_array[1];
        change_count+=1;
        if(isit_add===true){

          if(props_obj.cm_datas[i].when_syukka==='' && props_obj.cm_datas[i].hikiate_howmany!==0 && isit_alert===false){
            let alert_box = window.confirm('出荷日が空です\n今日の日にち('+today_str+')にして処理を継続しますか？');
            if(alert_box===false){
              _elm.innerHTML = '';
              stop = true;
              break;
            }else{
              props_obj.cm_datas[i].when_syukka=today_str;
              isit_alert = true;
            }
          }


          post_array.push(props_obj.cm_datas[i]);
          hikiate_post_ids.push(props_obj.cm_datas[i].id);
          hikiate_howmany = hikiate_howmany + this_howmany;
        }
        

        //if(props_obj.cm_datas[i].hattyuu_howmany>0){
        //  howmany_hattyuu++;
        //}
      }
    }

    if(stop===true){
      return 'check_false';
    }

    console.log('how many post_array '+String(post_array.length));
    console.log('hikiate_howmany '+String(hikiate_howmany));
    console.dir(post_array);

    if(hikiate_howmany<0){
      hikiate_howmany = 0;
    }

    if(post_array.length>0){
      fetch(settings.API_BASE_URL+'syukka_kakunin/' + '?token=' + auth_obj.token + '&name='+ auth_obj.name , {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({"data":post_array})
      })
      .then(response => response.json())
      .then(data => {
        console.dir(data);
        _elm.innerHTML = '';
        
        if(data.data.result==='zaiko_torikomi_runnning'){
          alert('今在庫データ取り込み中です.\n今のチェック内容は記録されていません.\n後ほどリトライお願いします！');
        }

      })
      .catch(error => {
        console.error(error);
        _elm.innerHTML = '';
        alert(error);
      });

    }else{
      _elm.innerHTML = '';
    }

    console.log(tonya_id);
    console.dir(props_obj);
    console.dir(hikiate_post_ids);
    return [hikiate_howmany, change_count, hikiate_post_ids];

  }




  createBackUp(auth_obj , headers, data, f_name, tonya_id){
    let isit_header = false;
    let header_array = [];
    for (let i = 0; i < headers.length; i++) {
      for (const [key, value] of Object.entries(headers[i])) {
        let what_type = key;
        let _val = value;
        if(what_type==='header'){
          isit_header = true;
          header_array.push(_val);
        }
      }
    }

    console.dir(header_array);

    //
    let post_data = [];
    if(header_array.length===0 || tonya_id===38){
      post_data = data;
    }else{
      post_data = [header_array].concat(data);
    }

    console.dir(post_data);

    if(post_data.length>0){
      fetch(settings.API_BASE_URL+'hattyuu_file_backup/' + '?token=' + auth_obj.token + '&name='+ auth_obj.name +'&tonya_id='+String(tonya_id)+'&f_name='+f_name , {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({"data":post_data})
      })
      .then(response => response.json())
      .then(data => {
        console.dir(data)
        
      })
      .catch(error => {
        console.error(error)
        alert(error);
        
      });

    }

  }








}

const addBoardFunction = new FunctionFields();

export { addBoardFunction };